import React from 'react';
import { Card, Badge, Row, Col } from 'react-bootstrap';

const fmt = (v) => v != null ? v : '-';

const CardDespesaVinculada = ({ despesa }) => {
  if (!despesa) return null;

  const tipoBadge = despesa.tipo === 'PJ'
    ? <Badge variant="primary">PJ — Solicitação de Pagamento</Badge>
    : <Badge variant="secondary">DP — Contas a Pagar</Badge>;

  return (
    <Card className="mb-3 border-warning">
      <Card.Header className="bg-warning text-dark">
        <strong>Despesa Vinculada</strong>
      </Card.Header>
      <Card.Body>
        <Row>
          <Col xs={12} sm={6} md={3} className="mb-2">
            <small className="text-muted d-block">Tipo</small>
            {tipoBadge}
          </Col>
          <Col xs={12} sm={6} md={3} className="mb-2">
            <small className="text-muted d-block">GE</small>
            <strong>{fmt(despesa.codigo_grupo_empresa)}</strong>
          </Col>
          <Col xs={12} sm={6} md={3} className="mb-2">
            <small className="text-muted d-block">Conta</small>
            <strong>{fmt(despesa.conta)}</strong>
          </Col>
          <Col xs={12} sm={6} md={3} className="mb-2">
            <small className="text-muted d-block">Código</small>
            <strong>{fmt(despesa.codigo)}</strong>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default CardDespesaVinculada;
